(() => {
  const CONTENT_PAGE_HANDLES = new Set([
    'kontakt',
    'versand',
    'zahlung',
    'bike-leasing',
    'impressum',
    'datenschutz',
    'agb',
    'widerruf-formular',
    'retouren-rucksendung',
    'e-bikes-kaufen',
    'e-bikes-thueringen',
    'fahrradgeschaeft-in-meiner-naehe',
    'dreirad',
    'amflow-thueringen'
  ]);

  const getPathParts = () => window.location.pathname.split('/').filter(Boolean);

  const applyPageClasses = () => {
    const body = document.body;
    if (!body) return;
    const parts = getPathParts();
    if (parts[0] === 'pages' && CONTENT_PAGE_HANDLES.has(parts[1] || '')) {
      body.classList.add('tm-content-page');
    }
    if (parts[0] === 'policies') {
      body.classList.add('tm-policy-page', 'tm-content-page');
    }
  };

  const analyticsAllowed = () => {
    try {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      return Boolean(
        privacy &&
        typeof privacy.analyticsProcessingAllowed === 'function' &&
        privacy.analyticsProcessingAllowed()
      );
    } catch (_error) {
      return false;
    }
  };

  const productContext = () => {
    const price = document.querySelector('product-price[data-product-id]');
    return {
      tm_product_id: price?.dataset.productId || undefined,
      tm_product_title: document.querySelector('.tm-product-hero h1')?.textContent?.trim() || undefined,
      tm_path: window.location.pathname,
      tm_source: 'themeseiten_optimierung'
    };
  };

  const publish = (eventName, details = {}) => {
    if (!analyticsAllowed()) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      ...productContext(),
      ...details
    });
  };

  const normalizedText = (element) => element?.textContent?.replace(/\s+/g, ' ').trim().slice(0, 120) || undefined;

  const classifyClick = (element) => {
    const anchor = element.closest('a');
    const href = anchor?.getAttribute('href') || '';
    const text = normalizedText(element);
    const lowerText = (text || '').toLowerCase();

    if (href.startsWith('tel:')) return ['tm_contact_phone', { tm_label: text }];
    if (href.startsWith('mailto:')) return ['tm_contact_email', { tm_label: text }];
    if (/wa\.me|whatsapp/i.test(href)) return ['tm_contact_whatsapp', { tm_label: text }];
    if (/google\.[^/]+\/maps|maps\.google|google\.com\/maps/i.test(href)) return ['tm_route_open', { tm_label: text }];
    if (href === '#kaufservice' || lowerText.includes('beratung öffnen')) return ['tm_consulting_open', { tm_label: text }];
    if (element.closest('.tm-size-inline, .tm-size-advisor')) return ['tm_size_help', { tm_label: text }];
    if (/\/pages\/bike-leasing(?:$|[?#/])/i.test(href) || lowerText.includes('leasing')) return ['tm_leasing_interest', { tm_label: text }];
    if (lowerText.includes('finanzierung') || lowerText.includes('klarna') || lowerText.includes('openbank') || lowerText.includes('rate')) {
      return ['tm_financing_interest', { tm_label: text }];
    }
    if (element.closest('.tm-buy-confidence__item summary')) return ['tm_service_detail_open', { tm_label: text }];
    return null;
  };

  document.addEventListener('click', (event) => {
    const element = event.target instanceof Element ? event.target.closest('a,button,summary') : null;
    if (!element) return;
    const classified = classifyClick(element);
    if (!classified) return;
    publish(classified[0], classified[1]);
  }, { capture: true });

  document.addEventListener('variant:update', (event) => {
    const variantId = event.detail?.resource?.id || event.detail?.variant?.id || event.detail?.data?.variant?.id;
    publish('tm_variant_selected', { tm_variant_id: variantId || undefined });
  });

  const installMobileBuybarObserver = () => {
    const buybar = document.querySelector('.tm-mobile-buybar');
    const buyArea = document.getElementById('produkt-kaufen');
    if (!buybar || !buyArea || typeof IntersectionObserver !== 'function') return;
    if (buybar.dataset.tmObserverBound === 'true') return;
    buybar.dataset.tmObserverBound = 'true';

    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      buybar.classList.toggle('is-hidden-by-buybox', Boolean(entry?.isIntersecting));
    }, { threshold: 0.12 });
    observer.observe(buyArea);
  };

  applyPageClasses();
  installMobileBuybarObserver();
  document.addEventListener('DOMContentLoaded', () => {
    applyPageClasses();
    installMobileBuybarObserver();
  }, { once: true });
  document.addEventListener('shopify:section:load', installMobileBuybarObserver);
})();
